import React from 'react';
import { ExternalLinkLinkWrapper, ViewMoreLinkWrapper } from './styles';
import { ReactComponent as RightTriangle } from 'images/dashboard/right-triangle.svg';

export const ViewMoreLink = ({ children, to, isExternalLink, ...rest }) => {
  const Content = () => (
    <>
      <span>{children}</span>
      <RightTriangle />
    </>
  );

  return (
    <>
      {isExternalLink
        ? (
          <ExternalLinkLinkWrapper
            href={to} {...rest} data-testid='external-link-wrapper'>
            <Content />
          </ExternalLinkLinkWrapper>
        )
        : (
          <ViewMoreLinkWrapper
            to={to} {...rest} data-testid='view-more-link-wrapper'>
            <Content />
          </ViewMoreLinkWrapper>
        )}
    </>
  );
};
